const langUserProfile = {
	title_my_profile: {
		tag: 'user.profile.title_my_profile',
		fr: 'Mon profil',
		en: 'My profile',
	},
	title_personal_information: {
		tag: 'user.profile.title_personal_information',
		fr: 'Informations personnelles',
		en: 'Personal information',
	},
	title_settings: {
		tag: 'user.profile.title_settings',
		fr: 'Paramètres',
		en: 'Settings',
	},
	title_notifications: {
		tag: 'user.profile.title_notifications',
		fr: 'Notifications automatiques',
		en: 'Automatic notifications',
	},
	title_security_method: {
		tag: 'user.profile.title_security_method',
		fr: 'Double authentification',
		en: 'Security method',
	},
	title_password: {
		tag: 'user.profile.title_password',
		fr: 'Mot de passe',
		en: 'Password',
	},
	btn_edit: {
		tag: 'user.profile.btn_edit',
		fr: 'Modifier',
		en: 'Edit',
	},
	btn_save: {
		tag: 'user.profile.btn_save',
		fr: 'Enregistrer',
		en: 'Save',
	},
	btn_close: {
		tag: 'user.profile.btn_close',
		fr: 'Fermer',
		en: 'Close',
	},
	btn_cancel: {
		tag: 'user.profile.btn_cancel',
		fr: 'Annuler',
		en: 'Cancel',
	},
	text_we_protect_your_personal_data: {
		tag: 'user.profile.text_we_protect_your_personal_data',
		fr: 'Nous protégeons vos données personnelles',
		en: 'We protect your personal data',
	},
	btn_contact_protection_officer: {
		tag: 'user.profile.btn_contact_protection_officer',
		fr: 'Contacter le responsable RGPD de Sienna',
		en: "Contact Sienna's Data Protection Officer",
	},

	text_you_have_configured: {
		tag: 'user.profile.text_you_have_configured',
		fr: 'Vous avez configuré <strong>{{nbSecurityMethod}} / {{totalSecurityMethod}}</strong>',
		en: 'You have set up <strong>{{nbSecurityMethod}} / {{totalSecurityMethod}}</strong>',
	},
	field_firstname: {
		tag: 'user.profile.field_firstname',
		fr: 'Prénom',
		en: 'First name',
	},
	field_lastname: {
		tag: 'user.profile.field_lastname',
		fr: 'Nom',
		en: 'Last name',
	},
	field_email: {
		tag: 'user.profile.field_email',
		fr: 'Adresse e-mail',
		en: 'E-mail address',
	},
	field_mobile_phone: {
		tag: 'user.profile.field_mobile_phone',
		fr: 'N° de mobile',
		en: 'Mobile phone',
	},
	field_my_organisation: {
		tag: 'user.profile.field_my_organisation',
		fr: 'Mon entreprise',
		en: 'My organisation',
	},
	field_my_organisations: {
		tag: 'user.profile.field_my_organisations',
		fr: 'Mes entreprises',
		en: 'My organisations',
	},
	field_rounding: {
		tag: 'user.profile.field_rounding',
		fr: 'Arrondi',
		en: 'Rounding',
	},
	field_language: {
		tag: 'user.profile.field_language',
		fr: 'Langue',
		en: 'Language',
	},
	field_realization_status: {
		tag: 'user.profile.field_realization_status',
		fr: 'Statut des fonds affichés',
		en: 'Realization status of displayed funds',
	},
	field_current_password: {
		tag: 'user.profile.field_current_password',
		fr: 'Mot de passe actuel',
		en: 'Current password',
	},
	field_new_password: {
		tag: 'user.profile.field_new_password',
		fr: 'Nouveau mot de passe',
		en: 'New password',
	},
	field_confirm_password: {
		tag: 'user.profile.field_confirm_password',
		fr: 'Confirmer le mot de passe',
		en: 'Confirm password',
	},
	factor_btn_setup: {
		tag: 'user.profile.factor_btn_setup',
		fr: 'Configurer',
		en: 'Setup now',
	},
	factor_btn_remove: {
		tag: 'user.profile.factor_btn_remove',
		fr: 'Supprimer',
		en: 'Remove',
	},
	factor_list_email_title: {
		tag: 'user.profile.factor_list_email_title',
		fr: 'Code reçu par e-mail',
		en: 'E-mail verification',
	},
	factor_list_email_title_short: {
		tag: 'user.profile.factor_list_email_title_short',
		fr: 'E-mail',
		en: 'E-mail',
	},
	factor_list_sms_title: {
		tag: 'user.profile.factor_list_sms_title',
		fr: 'Code reçu par SMS',
		en: 'SMS verification',
	},
	factor_list_sms_title_short: {
		tag: 'user.profile.factor_list_sms_title_short',
		fr: 'SMS',
		en: 'SMS',
	},
	factor_list_question_title: {
		tag: 'user.profile.factor_list_question_title',
		fr: 'Réponse à la question secrète',
		en: 'Security question with answer',
	},
	factor_list_question_title_short: {
		tag: 'user.profile.factor_list_question_title_short',
		fr: 'Question secrète',
		en: 'Security question',
	},
	alert_info_disable_edit_for_employee: {
		tag: 'user.profile.alert_info_disable_edit_for_employee',
		fr: 'Lorsque vous utilisez la vue employé, vous pouvez consulter les données du profil mais vous ne pouvez pas les modifier.',
		en: 'When using the employee view, you can view the profile data but you cannot edit it.',
	},
	error_password_update_api_password_used_too_recently: {
		tag: 'user.profile.error_password_update_api_password_used_too_recently',
		fr: 'Le nouveau mot de passe a été utilisé trop récemment',
		en: 'The new password has been used too recently',
	},
	label_for_block_information: {
		tag: 'user.profile.label_for_block_information',
		fr: 'Nom, Prénom, Entreprise',
		en: 'Lastname, Firstname, Company',
	},
	label_for_block_settings: {
		tag: 'user.profile.label_for_block_settings',
		fr: 'Arrondi, Langue, Statut des fonds',
		en: 'Rounding, Language, Realization status of funds',
	},
	label_for_block_notifications: {
		tag: 'user.profile.label_for_block_notifications',
		fr: 'Vous avez <strong>{{nbNotifications}} / {{nbNotificationsTotal}}</strong> notifications automatiques',
		en: 'You have <strong>{{nbNotifications}} / {{nbNotificationsTotal}}</strong> automatic notifications',
	},
	label_for_block_password: {
		tag: 'user.profile.label_for_block_password',
		fr: 'Mot de passe actuel : <strong>*************</strong>',
		en: 'Current password : <strong>*************</strong>',
	},
};

export default langUserProfile;
